import {FC} from 'react'
import {Link, useNavigate, useSearchParams} from 'react-router-dom'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {useAuth} from '../../../../app/modules/auth'

const CONTRACT_RUSHMIND_NOTIFICATION_TYPES = ['Análise de Contrato', 'Rushmind — Contrato']
const SPREADSHEET_IMPORT_NOTIFICATION_TYPES = ['Rushmind — Planilha']
const RUSHMIND_RECAP_NOTIFICATION_TYPES = ['rushmind_weekly_recap']

// O texto do recap vem do LLM em markdown (**negrito**, [texto](url)); no sino é texto puro.
const stripMarkdown = (text: string): string =>
  text.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1').replace(/\*\*|__/g, '')

const HeaderNotificationsMenu: FC = () => {
  const {currentUser} = useAuth()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const openNotification: {[key: string]: string} = {
    Projeto: '/projects',
    Tarefa: 'taskId=',
  }

  const openSpreadsheetImport = (notification: {
    data: {importId?: number; id?: number; projectId?: number; phase?: string; ai_status?: string}
  }) => {
    const importId = notification.data.importId ?? notification.data.id
    const projectId = notification.data.projectId
    const phase = notification.data.phase ?? notification.data.ai_status
    if (phase === 'completed' && projectId) {
      navigate(`/projects/${projectId}`)
      return
    }
    if (projectId && importId) {
      navigate(`/projects/${projectId}?spreadsheetImport=${importId}`)
      return
    }
    const newParams = new URLSearchParams(searchParams)
    newParams.set('spreadsheetImport', String(importId))
    setSearchParams(newParams)
  }

  const openContractAiSuggestions = (notification: {data: {contractId?: number; id?: number; projectId?: number}}) => {
    const contractId = notification.data.contractId ?? notification.data.id
    const projectId = notification.data.projectId
    if (projectId && contractId) {
      navigate(`/projects/${projectId}?contractAiSuggestions=${contractId}`)
      return
    }
    const newParams = new URLSearchParams(searchParams)
    newParams.set('contractAiSuggestions', String(contractId))
    setSearchParams(newParams)
  }

  const openTaskModal = (taskId: number) => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set('taskId', taskId!.toString()!)
    setSearchParams(newParams)
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px'
      data-kt-menu='true'
    >
      <div
        className='d-flex align-items-center px-9 pt-6 justify-content-between'
        style={{
          backgroundImage: `url('${toAbsoluteUrl('/media/misc/pattern-1.jpg')}')`,
          backgroundSize: 'cover',
        }}
      >
        <h3 className='text-dark fw-bold mb-0'>
          Notificações
          {/* <span className='fs-8 opacity-75 ps-3'>24 reports</span> */}
        </h3>
        {/* <button
          className='btn btn-secondary btn-sm d-flex align-items-center'
          title='Marcar todas como lidas'
        >
          <i className='bi bi-check2-all me-2'></i>
          Marcar todas como lidas
        </button> */}

        {/* <ul className='nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9'>
        <li className='nav-item'>
          <a
            className='nav-link text-white opacity-75 opacity-state-100 pb-4'
            data-bs-toggle='tab'
            href='#kt_topbar_notifications_1'
          >
            Alerts
          </a>
        </li>

        <li className='nav-item'>
          <a
            className='nav-link text-white opacity-75 opacity-state-100 pb-4 active'
            data-bs-toggle='tab'
            href='#kt_topbar_notifications_2'
          >
            Updates
          </a>
        </li>

        <li className='nav-item'>
          <a
            className='nav-link text-white opacity-75 opacity-state-100 pb-4'
            data-bs-toggle='tab'
            href='#kt_topbar_notifications_3'
          >
            Logs
          </a>
        </li>
      </ul> */}
      </div>

      <div className='tab-content'>
        <div className='tab-pane fade show active' id='kt_topbar_notifications_1' role='tabpanel'>
          <div className='scroll-y mh-325px my-5 px-8'>
            {currentUser?.unread_notifications?.length == 0 &&
            currentUser?.last_five_read_notifications?.length == 0 ? (
              <p className='text-muted fs-5'>Você não tem notificações.</p>
            ) : (
              <>
                {currentUser?.unread_notifications?.map((notification, index) => (
                  <div key={`alert${index}`} className='d-flex flex-stack py-4 position-relative'>
                    <span
                      className='bullet bullet-dot bg-danger h-6px w-6px position-absolute translate-middle animation-blink'
                      style={{top: 23, left: -8}}
                    />
                    {['Projeto'].includes(notification.data.type) ? (
                      <Link
                        to={`${openNotification[notification.data.type]}/${notification.data.id}`}
                      >
                        <div className='d-flex align-items-center'>
                          <div className='mb-0 me-2'>
                            <p className='fs-6 text-gray-800 fw-bolder mb-0'>
                              {notification.data.type.split('\\').pop()} #{notification.data.id} |{' '}
                              {notification.data.title}
                            </p>
                            <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                          </div>
                        </div>
                      </Link>
                    ) : ['Tarefa'].includes(notification.data.type) ? (
                      <div
                        className='d-flex align-items-center'
                        role='button'
                        onClick={() => openTaskModal(notification.data.id)}
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>
                            {notification.data.type
                              ? `${notification.data.type.split('\\').pop()} #${
                                  notification.data.id
                                } | `
                              : ''}
                            {notification.data.title}
                          </p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                          {notification.data.assigned_by && (
                            <p className='text-gray-500 fs-8 fst-italic'>
                              Atribuído por: {notification.data.assigned_by}
                            </p>
                          )}
                        </div>
                      </div>
                    ) : ['Ticket'].includes(notification.data.type) ? (
                      <Link
                        to='/client-portal-tickets'
                        className='d-flex align-items-center'
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>
                            {notification.data.type
                              ? `${notification.data.type.split('\\').pop()} #${
                                  notification.data.id
                                } | `
                              : ''}
                            {notification.data.title}
                          </p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </Link>
                    ) : ['Cronograma'].includes(notification.data.type) ? (
                      <Link
                        to={`projects/${notification.data.projectId}`}
                        className='d-flex align-items-center'
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>
                            {notification.data.type
                              ? `${notification.data.type.split('\\').pop()} #${
                                  notification.data.id
                                } | `
                              : ''}
                            {notification.data.title}
                          </p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </Link>
                    ) : ['Nota de Lançamento'].includes(notification.data.type) ? (
                      <div
                        role='button'
                        className='d-flex align-items-center'
                        onClick={() => {
                          const newParams = new URLSearchParams(searchParams)
                          newParams.set('releaseNoteId', String(notification.data.id))
                          setSearchParams(newParams)
                        }}
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>
                            {notification.data.type
                              ? `${notification.data.type.split('\\').pop()} | `
                              : ''}
                            {notification.data.title}
                          </p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </div>
                    ) : SPREADSHEET_IMPORT_NOTIFICATION_TYPES.includes(notification.data.type) ? (
                      <div
                        role='button'
                        className='d-flex align-items-center'
                        onClick={() => openSpreadsheetImport(notification)}
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>{notification.data.title}</p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </div>
                    ) : ['Integração'].includes(notification.data.type) ? (
                      <div className='d-flex align-items-center'>
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>{notification.data.title}</p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </div>
                    ) : RUSHMIND_RECAP_NOTIFICATION_TYPES.includes(notification.data.type) ? (
                      <div
                        role='button'
                        className='d-flex align-items-center'
                        onClick={() => navigate(notification.data.url ?? '/meu-desempenho')}
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>{notification.data.title}</p>
                          <p className='text-gray-400 fs-7 mb-0'>
                            {stripMarkdown(notification.data.message)}
                          </p>
                        </div>
                      </div>
                    ) : CONTRACT_RUSHMIND_NOTIFICATION_TYPES.includes(notification.data.type) ? (
                      <div
                        role='button'
                        className='d-flex align-items-center'
                        onClick={() => openContractAiSuggestions(notification)}
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>{notification.data.title}</p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </div>
                    ) : (
                      <div className='d-flex align-items-center'>
                        {/* <div className='symbol symbol-35px me-4'>
                        <span className={clsx('symbol-label', `bg-light-${alert.state}`)}>
                        {' '}
                        <KTSVG
                        path={`/media/${alert.icon}`}
                        className={`svg-icon-2 svg-icon-${alert.state}`}
                        />
                        </span>
                        </div> */}
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>
                            {notification.data.type
                              ? `${notification.data.type.split('\\').pop()} #${
                                  notification.data.id
                                } | `
                              : ''}
                            {notification.data.title}
                          </p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </div>
                    )}
                    {/* <span className='badge badge-light fs-8'>{notification.time}</span> */}
                  </div>
                ))}

                {currentUser?.last_five_read_notifications?.map((notification, index) => (
                  <div key={`read-alert${index}`} className='d-flex flex-stack py-4'>
                    {SPREADSHEET_IMPORT_NOTIFICATION_TYPES.includes(notification.data.type) ? (
                      <div
                        role='button'
                        className='d-flex align-items-center'
                        onClick={() => openSpreadsheetImport(notification)}
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>{notification.data.title}</p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </div>
                    ) : RUSHMIND_RECAP_NOTIFICATION_TYPES.includes(notification.data.type) ? (
                      <div
                        role='button'
                        className='d-flex align-items-center'
                        onClick={() => navigate(notification.data.url ?? '/meu-desempenho')}
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>{notification.data.title}</p>
                          <p className='text-gray-400 fs-7 mb-0'>
                            {stripMarkdown(notification.data.message)}
                          </p>
                        </div>
                      </div>
                    ) : CONTRACT_RUSHMIND_NOTIFICATION_TYPES.includes(notification.data.type) ? (
                      <div
                        role='button'
                        className='d-flex align-items-center'
                        onClick={() => openContractAiSuggestions(notification)}
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>{notification.data.title}</p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </div>
                    ) : ['Projeto'].includes(notification.data.type) ? (
                      <Link
                        to={`${openNotification[notification.data.type]}/${notification.data.id}`}
                      >
                        <div className='d-flex align-items-center'>
                          <div className='mb-0 me-2'>
                            <p className='fs-6 text-gray-800 fw-bolder mb-0'>
                              {notification.data.type.split('\\').pop()} #{notification.data.id} |{' '}
                              {notification.data.title}
                            </p>
                            <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                          </div>
                        </div>
                      </Link>
                    ) : ['Tarefa'].includes(notification.data.type) ? (
                      <div
                        className='d-flex align-items-center'
                        role='button'
                        onClick={() => openTaskModal(notification.data.id)}
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>
                            {notification.data.type
                              ? `${notification.data.type.split('\\').pop()} #${
                                  notification.data.id
                                } | `
                              : ''}
                            {notification.data.title}
                          </p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                          {notification.data.assigned_by && (
                            <p className='text-gray-500 fs-8 fst-italic'>
                              Atribuído por: {notification.data.assigned_by}
                            </p>
                          )}
                        </div>
                      </div>
                    ) : ['Ticket'].includes(notification.data.type) ? (
                      <Link
                        to='/client-portal-tickets'
                        className='d-flex align-items-center'
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>
                            {notification.data.type
                              ? `${notification.data.type.split('\\').pop()} #${
                                  notification.data.id
                                } | `
                              : ''}
                            {notification.data.title}
                          </p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </Link>
                    ) : ['Cronograma'].includes(notification.data.type) ? (
                      <Link
                        to={`projects/${notification.data.projectId}`}
                        className='d-flex align-items-center'
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>
                            {notification.data.type
                              ? `${notification.data.type.split('\\').pop()} #${
                                  notification.data.id
                                } | `
                              : ''}
                            {notification.data.title}
                          </p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </Link>
                    ) : ['Nota de Lançamento'].includes(notification.data.type) ? (
                      <div
                        role='button'
                        className='d-flex align-items-center'
                        onClick={() => {
                          const newParams = new URLSearchParams(searchParams)
                          newParams.set('releaseNoteId', String(notification.data.id))
                          setSearchParams(newParams)
                        }}
                      >
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>
                            {notification.data.type
                              ? `${notification.data.type.split('\\').pop()} | `
                              : ''}
                            {notification.data.title}
                          </p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </div>
                    ) : ['Integração'].includes(notification.data.type) ? (
                      <div className='d-flex align-items-center'>
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>{notification.data.title}</p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </div>
                    ) : (
                      <div className='d-flex align-items-center'>
                        {/* <div className='symbol symbol-35px me-4'>
                        <span className={clsx('symbol-label', `bg-light-${alert.state}`)}>
                        {' '}
                        <KTSVG
                        path={`/media/${alert.icon}`}
                        className={`svg-icon-2 svg-icon-${alert.state}`}
                        />
                        </span>
                        </div> */}
                        <div className='mb-0 me-2'>
                          <p className='fs-6 text-gray-800 fw-bolder mb-0'>
                            {notification.data.type
                              ? `${notification.data.type.split('\\').pop()} #${
                                  notification.data.id
                                } | `
                              : ''}
                            {notification.data.title}
                          </p>
                          <p className='text-gray-400 fs-7 mb-0'>{notification.data.message}</p>
                        </div>
                      </div>
                    )}
                    {/* <span className='badge badge-light fs-8'>{notification.time}</span> */}
                  </div>
                ))}
              </>
            )}
          </div>

          {/* <div className='py-3 text-center border-top'>
            <Link
              to='/crafted/pages/profile'
              className='btn btn-color-gray-600 btn-active-color-primary'
            >
              View All{' '}
              <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
            </Link>
          </div> */}
        </div>

        {/* <div className='tab-pane fade show active' id='kt_topbar_notifications_2' role='tabpanel'>
        <div className='d-flex flex-column px-9'>
          <div className='pt-10 pb-0'>
            <h3 className='text-dark text-center fw-bolder'>Get Pro Access</h3>

            <div className='text-center text-gray-600 fw-bold pt-1'>
              Outlines keep you honest. They stoping you from amazing poorly about drive
            </div>

            <div className='text-center mt-5 mb-9'>
              <a
                href='#'
                className='btn btn-sm btn-primary px-6'
                data-bs-toggle='modal'
                data-bs-target='#kt_modal_upgrade_plan'
              >
                Upgrade
              </a>
            </div>
          </div>

          <div className='text-center px-4'>
            <span className='empty-state-icon' aria-hidden='true'><i className='bi bi-bell'></i></span>
          </div>
        </div>
      </div> */}

        {/* <div className='tab-pane fade' id='kt_topbar_notifications_3' role='tabpanel'>
        <div className='scroll-y mh-325px my-5 px-8'>
          {defaultLogs.map((log, index) => (
            <div key={`log${index}`} className='d-flex flex-stack py-4'>
              <div className='d-flex align-items-center me-2'>
                <span className={clsx('w-70px badge', `badge-light-${log.state}`, 'me-4')}>
                  {log.code}
                </span>

                <a href='#' className='text-gray-800 text-hover-primary fw-bold'>
                  {log.message}
                </a>

                <span className='badge badge-light fs-8'>{log.time}</span>
              </div>
            </div>
          ))}
        </div>
        <div className='py-3 text-center border-top'>
          <Link
            to='/crafted/pages/profile'
            className='btn btn-color-gray-600 btn-active-color-primary'
          >
            View All <KTSVG path='/media/icons/duotune/arrows/arr064.svg' className='svg-icon-5' />
          </Link>
        </div>
      </div> */}
      </div>
    </div>
  )
}

export {HeaderNotificationsMenu}
